import React, { useState, useEffect, useCallback } from 'react';
import './AdminLeads.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/leads.php';

/* ── Icons ── */
const IconUsers    = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconMail     = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCart     = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><circle cx="9" cy="21" r="1" stroke="currentColor" strokeWidth="2"/><circle cx="20" cy="21" r="1" stroke="currentColor" strokeWidth="2"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconDownload = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><polyline points="7 10 12 15 17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconStar     = () => (<svg viewBox="0 0 24 24" fill="#f59e0b" width="13" height="13"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>);
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSearch   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconWeb      = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconInstagram= () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>);
const IconArrow    = () => (<svg viewBox="0 0 20 20" fill="none" width="13" height="13"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconPlus     = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconDollar   = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><line x1="12" y1="1" x2="12" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

/* ── Helpers ── */
const FUENTE_ICON = { instagram:<IconInstagram/>, facebook:<IconInstagram/>, whatsapp:<IconWhatsapp/>, web:<IconWeb/>, boletin:<IconMail/>, directo:<IconWeb/> };
const PERFIL_COLORS = { profesional:'verde', familia:'azul', estudiante:'amarillo', otro:'gris' };
const ESTADO_COLORS = { pagado:'verde', pendiente:'amarillo', parcial:'azul', cancelado:'rojo', reembolsado:'gris' };
const CANAL_ICON = { web:<IconWeb/>, whatsapp:<IconWhatsapp/> };

function fmtFecha(str) {
  if (!str) return '—';
  const d = new Date(str);
  return d.toLocaleDateString('es-PE',{day:'2-digit',month:'short',year:'numeric'});
}
function fmtMonto(n) {
  return 'S/. ' + parseFloat(n||0).toFixed(2);
}

/* ════════════════════════════════════════
   COMPONENTE PRINCIPAL
════════════════════════════════════════ */
export default function AdminLeads() {
  const [tab,       setTab]      = useState('stats'); // stats | leads | suscriptores | compras | recursos
  const [stats,     setStats]    = useState(null);
  const [leads,     setLeads]    = useState([]);
  const [susc,      setSusc]     = useState([]);
  const [compras,   setCompras]  = useState([]);
  const [recursos,  setRecursos] = useState([]);
  const [loading,   setLoading]  = useState(false);
  const [busqueda,  setBusqueda] = useState('');
  const [toast,     setToast]    = useState(null);

  // Modal nueva compra
  const [modalCompra, setModalCompra] = useState(false);
  const [formCompra,  setFormCompra]  = useState({ nombre:'', email:'', telefono:'', perfil:'profesional', tipo_producto:'formacion', producto_nombre:'', monto_total:'', monto_pagado:'', canal:'whatsapp', metodo_pago:'Yape', estado:'pagado', notas:'' });
  const [guardando,   setGuardando]   = useState(false);

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3000); };

  /* ── Fetch stats ── */
  const fetchStats = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=stats`);
      const j = await r.json();
      if (j.success) setStats(j.data);
    } catch(e) { showToast('Error cargando stats','error'); }
    finally { setLoading(false); }
  }, []);

  /* ── Fetch leads desde BD directa (via stats por ahora) ── */
  const fetchLeads = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=leads_list`);
      const j = await r.json();
      if (j.success) setLeads(j.data || []);
    } catch(e) {}
    finally { setLoading(false); }
  }, []);

  const fetchSusc = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=suscriptores_list`);
      const j = await r.json();
      if (j.success) setSusc(j.data || []);
    } catch(e) {}
    finally { setLoading(false); }
  }, []);

  const fetchCompras = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=compras_list`);
      const j = await r.json();
      if (j.success) setCompras(j.data || []);
    } catch(e) {}
    finally { setLoading(false); }
  }, []);

  const fetchRecursos = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=recursos`);
      const j = await r.json();
      if (j.success) setRecursos(j.data || []);
    } catch(e) {}
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    fetchStats();
    if (tab === 'leads')        fetchLeads();
    if (tab === 'suscriptores') fetchSusc();
    if (tab === 'compras')      fetchCompras();
    if (tab === 'recursos')     fetchRecursos();
  }, [tab]);

  /* ── Registrar compra manual ── */
  const registrarCompra = async () => {
    if (!formCompra.nombre || !formCompra.email || !formCompra.producto_nombre || !formCompra.monto_total) {
      showToast('Completa los campos obligatorios','error'); return;
    }
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=compra`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ ...formCompra, monto_total: parseFloat(formCompra.monto_total), monto_pagado: parseFloat(formCompra.monto_pagado||formCompra.monto_total) }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast(`Compra registrada. Puntos: ${j.data?.puntos_ganados || 0}`);
      setModalCompra(false);
      fetchStats(); fetchCompras();
    } catch(e) { showToast(e.message,'error'); }
    finally { setGuardando(false); }
  };

  // Filtrado local
  const q = busqueda.toLowerCase();
  const filtrarLeads   = leads.filter(l   => !q || l.nombre?.toLowerCase().includes(q) || l.email?.toLowerCase().includes(q));
  const filtrarSusc    = susc.filter(s    => !q || s.nombre?.toLowerCase().includes(q) || s.email?.toLowerCase().includes(q));
  const filtrarCompras = compras.filter(c => !q || c.nombre?.toLowerCase().includes(q) || c.email?.toLowerCase().includes(q) || c.producto_nombre?.toLowerCase().includes(q));

  /* ── Links landing ── */
  const baseUrl = 'https://centrocomunicar.com/gratis';

  return (
    <div className="al2-page">

      {toast && (
        <div className={`al2-toast al2-toast--${toast.tipo}`}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* HEADER */}
      <div className="al2-header">
        <div>
          <h1>Leads & Marketing</h1>
          <p>Gestiona suscriptores, leads, descargas y ventas</p>
        </div>
        <div className="al2-header__actions">
          <button className="al2-btn-ghost" onClick={()=>{fetchStats();showToast('Datos actualizados')}}>
            <IconRefresh/> Actualizar
          </button>
          <button className="al2-btn-primary" onClick={()=>setModalCompra(true)}>
            <IconPlus/> Nueva venta
          </button>
        </div>
      </div>

      {/* TABS */}
      <div className="al2-tabs">
        {[
          { id:'stats',        label:'Dashboard',    Icon:IconStar },
          { id:'leads',        label:'Leads',        Icon:IconUsers },
          { id:'suscriptores', label:'Boletín',      Icon:IconMail },
          { id:'compras',      label:'Ventas',       Icon:IconCart },
          { id:'recursos',     label:'Recursos',     Icon:IconDownload },
        ].map(({id,label,Icon}) => (
          <button key={id} className={`al2-tab ${tab===id?'al2-tab--active':''}`} onClick={()=>setTab(id)}>
            <Icon/> {label}
          </button>
        ))}
      </div>

      {/* ════════════════════
          TAB: STATS
      ════════════════════ */}
      {tab==='stats' && (
        <div className="al2-stats">
          {/* KPIs */}
          <div className="al2-kpis">
            <div className="al2-kpi al2-kpi--verde">
              <div className="al2-kpi__icon"><IconUsers/></div>
              <p>Total leads</p>
              <strong>{loading ? '…' : (stats?.total_leads || 0)}</strong>
              <span>Usuarios registrados</span>
            </div>
            <div className="al2-kpi">
              <div className="al2-kpi__icon al2-kpi__icon--azul"><IconMail/></div>
              <p>Suscriptores activos</p>
              <strong>{loading ? '…' : (stats?.total_suscriptores || 0)}</strong>
              <span>Reciben el boletín</span>
            </div>
            <div className="al2-kpi">
              <div className="al2-kpi__icon al2-kpi__icon--amarillo"><IconDownload/></div>
              <p>Descargas totales</p>
              <strong>{loading ? '…' : (stats?.total_descargas || 0)}</strong>
              <span>Recursos descargados</span>
            </div>
            <div className="al2-kpi">
              <div className="al2-kpi__icon al2-kpi__icon--rosa"><IconDollar/></div>
              <p>Ingresos totales</p>
              <strong>{loading ? '…' : fmtMonto(stats?.ingresos_totales || 0)}</strong>
              <span>{stats?.total_ventas || 0} ventas registradas</span>
            </div>
          </div>

          {/* Top recursos */}
          {stats?.top_recursos?.length > 0 && (
            <div className="al2-card">
              <div className="al2-card__head">
                <h3>Top recursos por descargas</h3>
              </div>
              <div className="al2-tabla-wrap">
                <table className="al2-tabla">
                  <thead><tr><th>#</th><th>Recurso</th><th>Tipo</th><th>Descargas</th></tr></thead>
                  <tbody>
                    {stats.top_recursos.map((r,i) => (
                      <tr key={i}>
                        <td><span className="al2-num">{i+1}</span></td>
                        <td><strong>{r.titulo}</strong></td>
                        <td><span className={`al2-badge al2-badge--${r.tipo}`}>{r.tipo}</span></td>
                        <td><strong>{r.total_descargas}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Links para campañas */}
          <div className="al2-card">
            <div className="al2-card__head">
              <h3>Links de captación por recurso</h3>
              <span className="al2-card__sub">Comparte estos links en tus redes para captar leads</span>
            </div>
            <div className="al2-links-grid">
              {recursos.length === 0 ? (
                <p className="al2-empty-text">Cargando recursos… <button className="al2-link-btn" onClick={fetchRecursos}>Cargar</button></p>
              ) : recursos.map(r => (
                <div className="al2-link-card" key={r.id}>
                  <div className="al2-link-card__top">
                    <span className={`al2-badge al2-badge--${r.tipo}`}>{r.tipo}</span>
                    <strong>{r.titulo}</strong>
                  </div>
                  <div className="al2-link-card__links">
                    {[
                      { label:'Instagram', param:'instagram', Icon:IconInstagram },
                      { label:'WhatsApp',  param:'whatsapp',  Icon:IconWhatsapp },
                      { label:'QR/Otros',  param:'qr',        Icon:IconWeb },
                    ].map(({label,param,Icon}) => {
                      const url = `${baseUrl}/${r.slug}?utm_source=${param}&utm_medium=social&utm_campaign=${r.utm_campaign||r.slug}`;
                      return (
                        <div className="al2-link-row" key={param}>
                          <span className="al2-link-row__label"><Icon/> {label}</span>
                          <span className="al2-link-row__url">{url}</span>
                          <button
                            className="al2-link-copy"
                            onClick={()=>{ navigator.clipboard.writeText(url); showToast('Link copiado'); }}
                          >
                            Copiar
                          </button>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ════════════════════
          TAB: LEADS
      ════════════════════ */}
      {tab==='leads' && (
        <div className="al2-section">
          <div className="al2-toolbar">
            <div className="al2-search">
              <IconSearch/>
              <input type="text" placeholder="Buscar por nombre o email…" value={busqueda} onChange={e=>setBusqueda(e.target.value)}/>
            </div>
            <span className="al2-count">{filtrarLeads.length} leads</span>
          </div>
          <div className="al2-tabla-wrap al2-card">
            <table className="al2-tabla">
              <thead><tr><th>Nombre</th><th>Email</th><th>Teléfono</th><th>Perfil</th><th>Fuente</th><th>Recurso</th><th>Puntos</th><th>Fecha</th></tr></thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="8" className="al2-loading-row">Cargando…</td></tr>
                ) : filtrarLeads.length === 0 ? (
                  <tr><td colSpan="8" className="al2-empty-row">
                    {leads.length === 0 ? 'Aún no hay leads registrados' : 'Sin resultados para esa búsqueda'}
                  </td></tr>
                ) : filtrarLeads.map(l => (
                  <tr key={l.id} className="al2-tr">
                    <td><strong>{l.nombre}</strong></td>
                    <td><span className="al2-email">{l.email}</span></td>
                    <td>{l.telefono || <span className="al2-nd">—</span>}</td>
                    <td><span className={`al2-badge al2-badge--${PERFIL_COLORS[l.perfil]||'gris'}`}>{l.perfil}</span></td>
                    <td>
                      <span className="al2-fuente">
                        {FUENTE_ICON[l.fuente] || <IconWeb/>}
                        {l.fuente || 'web'}
                      </span>
                    </td>
                    <td><span className="al2-recurso-slug">{l.recurso_slug || <span className="al2-nd">—</span>}</span></td>
                    <td><span className="al2-puntos-badge">{l.puntos || 0} pts</span></td>
                    <td className="al2-fecha">{fmtFecha(l.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ════════════════════
          TAB: SUSCRIPTORES
      ════════════════════ */}
    {tab==='suscriptores' && (
  <div className="al2-section">
    <div className="al2-toolbar">
      <div className="al2-search">
        <IconSearch/>
        <input
          type="text"
          placeholder="Buscar suscriptor…"
          value={busqueda}
          onChange={e=>setBusqueda(e.target.value)}
        />
      </div>
      <span className="al2-count">{filtrarSusc.length} suscriptores</span>
    </div>

    {/* KPI rápido */}
    <div className="al2-susc-kpis">
      <div className="al2-susc-kpi">
        <strong>{filtrarSusc.length}</strong>
        <span>Total suscriptores</span>
      </div>
      <div className="al2-susc-kpi al2-susc-kpi--verde">
        <strong>
          {filtrarSusc.reduce((acc, s) => acc + (parseInt(s.total_descargas)||0), 0)}
        </strong>
        <span>Descargas totales</span>
      </div>
      <div className="al2-susc-kpi">
        <strong>
          {filtrarSusc.filter(s => s.confirmado == 1).length}
        </strong>
        <span>Emails confirmados</span>
      </div>
      <div className="al2-susc-kpi">
        <strong>
          {filtrarSusc.filter(s => parseInt(s.total_descargas) > 0).length}
        </strong>
        <span>Con descargas</span>
      </div>
    </div>

    <div className="al2-tabla-wrap al2-card">
      <table className="al2-tabla">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Perfil</th>
            <th>Fuente</th>
            <th>Descargas</th>
            <th>Recursos descargados</th>
            <th>Estado</th>
            <th>Confirmado</th>
            <th>Fecha</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan="9" className="al2-loading-row">Cargando…</td></tr>
          ) : filtrarSusc.length === 0 ? (
            <tr><td colSpan="9" className="al2-empty-row">
              {susc.length === 0 ? 'Aún no hay suscriptores' : 'Sin resultados'}
            </td></tr>
          ) : filtrarSusc.map(s => (
            <tr key={s.id} className="al2-tr">
              <td><strong>{s.nombre}</strong></td>
              <td><span className="al2-email">{s.email}</span></td>
              <td>
                <span className={`al2-badge al2-badge--${PERFIL_COLORS[s.perfil]||'gris'}`}>
                  {s.perfil}
                </span>
              </td>
              <td>
                <span className="al2-fuente">
                  {FUENTE_ICON[s.fuente]||<IconWeb/>} {s.fuente||'web'}
                </span>
              </td>
              <td>
                <span className={`al2-desc-count ${parseInt(s.total_descargas)>0?'al2-desc-count--ok':''}`}>
                  {s.total_descargas || 0}
                </span>
              </td>
              <td>
                <span className="al2-recursos-list" title={s.recursos_descargados||''}>
                  {s.recursos_descargados
                    ? s.recursos_descargados.length > 50
                      ? s.recursos_descargados.slice(0,50) + '…'
                      : s.recursos_descargados
                    : <span className="al2-nd">Ninguno aún</span>
                  }
                </span>
              </td>
              <td>
                <span className={`al2-estado al2-estado--${s.activo?'activo':'inactivo'}`}>
                  {s.activo?'Activo':'Inactivo'}
                </span>
              </td>
              <td>
                {s.confirmado
                  ? <span className="al2-confirmado"><IconCheck/> Sí</span>
                  : <span className="al2-nd">Pendiente</span>
                }
              </td>
              <td className="al2-fecha">{fmtFecha(s.created_at)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

      {/* ════════════════════
          TAB: COMPRAS
      ════════════════════ */}
      {tab==='compras' && (
        <div className="al2-section">
          <div className="al2-toolbar">
            <div className="al2-search">
              <IconSearch/>
              <input type="text" placeholder="Buscar por nombre, email o producto…" value={busqueda} onChange={e=>setBusqueda(e.target.value)}/>
            </div>
            <span className="al2-count">{filtrarCompras.length} ventas</span>
            <button className="al2-btn-primary" onClick={()=>setModalCompra(true)}>
              <IconPlus/> Nueva venta
            </button>
          </div>
          <div className="al2-tabla-wrap al2-card">
            <table className="al2-tabla">
              <thead><tr><th>Cliente</th><th>Producto</th><th>Canal</th><th>Monto</th><th>Pagado</th><th>Estado</th><th>Puntos</th><th>Fecha</th></tr></thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="8" className="al2-loading-row">Cargando…</td></tr>
                ) : filtrarCompras.length === 0 ? (
                  <tr><td colSpan="8" className="al2-empty-row">
                    {compras.length === 0 ? 'Aún no hay ventas registradas' : 'Sin resultados'}
                  </td></tr>
                ) : filtrarCompras.map(c => (
                  <tr key={c.id} className="al2-tr">
                    <td>
                      <strong>{c.nombre}</strong>
                      <span className="al2-sub">{c.email}</span>
                    </td>
                    <td>
                      <strong>{c.producto_nombre}</strong>
                      <span className="al2-sub">{c.tipo_producto}</span>
                    </td>
                    <td><span className="al2-fuente">{CANAL_ICON[c.canal]||<IconWeb/>} {c.canal}</span></td>
                    <td><strong className="al2-monto">{fmtMonto(c.monto_total)}</strong></td>
                    <td>{fmtMonto(c.monto_pagado)}</td>
                    <td><span className={`al2-estado al2-estado--${ESTADO_COLORS[c.estado]||'gris'}`}>{c.estado}</span></td>
                    <td><span className="al2-puntos-badge">{c.puntos_ganados || 0} pts</span></td>
                    <td className="al2-fecha">{fmtFecha(c.fecha_compra)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* ════════════════════
          TAB: RECURSOS
      ════════════════════ */}
      {tab==='recursos' && (
        <div className="al2-section">
          <div className="al2-toolbar">
            <span className="al2-count">{recursos.length} recursos gratuitos</span>
          </div>
          <div className="al2-recursos-grid">
            {recursos.map(r => (
              <div className="al2-recurso-card" key={r.id}>
                <div className="al2-recurso-card__top">
                  <span className={`al2-badge al2-badge--${r.tipo}`}>{r.tipo}</span>
                  {r.categoria && <span className="al2-badge al2-badge--gris">{r.categoria}</span>}
                </div>
                <h4>{r.titulo}</h4>
                <p>{r.descripcion}</p>
                <div className="al2-recurso-card__stats">
                  <span><IconDownload/> {r.total_descargas} descargas</span>
                </div>
                <div className="al2-recurso-card__link">
                  <span className="al2-link-url">/gratis/{r.slug}</span>
                  <button
                    className="al2-link-copy"
                    onClick={()=>{ navigator.clipboard.writeText(`https://centrocomunicar.com/gratis/${r.slug}`); showToast('Link copiado'); }}
                  >
                    Copiar link
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ════════════════════
          MODAL NUEVA COMPRA
      ════════════════════ */}
      {modalCompra && (
        <div className="al2-overlay" onClick={()=>setModalCompra(false)}>
          <div className="al2-modal" onClick={e=>e.stopPropagation()}>
            <div className="al2-modal__head">
              <div><h2>Registrar venta</h2><p>Web o WhatsApp</p></div>
              <button className="al2-modal__close" onClick={()=>setModalCompra(false)}><IconClose/></button>
            </div>
            <div className="al2-modal__body">
              <div className="al2-form-grid">
                {[
                  { label:'Nombre *',         key:'nombre',          type:'text',   placeholder:'Ej: Ana Rodríguez' },
                  { label:'Email *',           key:'email',           type:'email',  placeholder:'ana@correo.com' },
                  { label:'Teléfono',          key:'telefono',        type:'tel',    placeholder:'+51 999 000 111' },
                  { label:'Producto *',        key:'producto_nombre', type:'text',   placeholder:'Ej: Kit TEA completo' },
                  { label:'Monto total (S/.) *',key:'monto_total',   type:'number', placeholder:'0.00' },
                  { label:'Monto pagado (S/.)', key:'monto_pagado',  type:'number', placeholder:'0.00' },
                  { label:'Referencia de pago',key:'referencia_pago',type:'text',   placeholder:'Nro. operación Yape, etc.' },
                  { label:'Notas',             key:'notas',           type:'text',   placeholder:'Observaciones opcionales' },
                ].map(({label,key,type,placeholder}) => (
                  <div className="al2-field" key={key}>
                    <label>{label}</label>
                    <input type={type} className="al2-input" placeholder={placeholder}
                      value={formCompra[key]||''} onChange={e=>setFormCompra(f=>({...f,[key]:e.target.value}))}/>
                  </div>
                ))}
                {/* Selects */}
                {[
                  { label:'Perfil',         key:'perfil',         opts:['profesional','familia','estudiante','otro'] },
                  { label:'Tipo producto',  key:'tipo_producto',  opts:['formacion','recurso','kit','juego','otro'] },
                  { label:'Canal',          key:'canal',          opts:['whatsapp','web','presencial','otro'] },
                  { label:'Método de pago', key:'metodo_pago',    opts:['Yape','Plin','Transferencia','Tarjeta','Efectivo','Otro'] },
                  { label:'Estado',         key:'estado',         opts:['pagado','pendiente','parcial','cancelado'] },
                ].map(({label,key,opts}) => (
                  <div className="al2-field" key={key}>
                    <label>{label}</label>
                    <select className="al2-input al2-sel" value={formCompra[key]||''} onChange={e=>setFormCompra(f=>({...f,[key]:e.target.value}))}>
                      {opts.map(o=><option key={o}>{o}</option>)}
                    </select>
                  </div>
                ))}
              </div>
            </div>
            <div className="al2-modal__foot">
              <button className="al2-btn-ghost" onClick={()=>setModalCompra(false)} disabled={guardando}>Cancelar</button>
              <button className="al2-btn-primary" onClick={registrarCompra} disabled={guardando}>
                {guardando ? <span className="al2-spinner"/> : <><IconCart/> Registrar venta</>}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}